exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".offer-message[data-v-ce426f5a]{padding:5px 0;margin:0;list-style:none;white-space:normal;margin-top:7px;width:100%;text-align:left}", "", {"version":3,"sources":["/app/src/components/payment/walletMessage.vue"],"names":[],"mappings":"AACA,gCACI,cAAe,AACf,SAAU,AACV,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AAChB,WAAY,AACZ,eAAiB,CACpB","file":"walletMessage.vue","sourcesContent":["\n.offer-message[data-v-ce426f5a] {\n    padding: 5px 0;\n    margin: 0;\n    list-style: none;\n    white-space: normal;\n    margin-top: 7px;\n    width: 100%;\n    text-align: left;\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ce426f5a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/payment/walletMessage.vue
// module id = 1519
// module chunks = 13 14